export const centsToFloat = (cents: number) => {
  const float = cents / 100;

  return float;
};
